import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2f774a9e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2f774a9e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f774a9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f774a9e')) {
      api.createRecord('2f774a9e', component.options)
    } else {
      api.reload('2f774a9e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2f774a9e&scoped=true", function () {
      api.rerender('2f774a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/pages/new-panorama/index.vue"
export default component.exports